import * as React from 'react';

export const CompanyContext = React.createContext<{ name: string }>(null);
